import React, { useState, useReducer, useEffect } from "react";
import {
  Button,
  Grid,
  Modal,
  TextArea,
  Icon,
  Segment,
  Menu,
} from "semantic-ui-react";
import {
  initialState,
  reducer,
  ACTION,
} from "../../../Reducer/InitialStateReducer";

import { server } from "../../../App";
import axios from "axios";
import { columnDefs, defaultColDef } from "./GridParamsColumn1/GridParams";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

function Note(props) {
  const [state, dispatch] = useReducer(reducer, initialState);

  // const [SelectedCategorie, setSelectedCategorie] = useState("");
  // const [SelectedCategorieText, setSelectedCategorieText] = useState('Acte Proposé');
  // ag grid state
  const [, setGridApi] = useState(null);
  const [, setGridColumnApi] = useState(null);

  const { ID, syncData, option, AuthState } = props;

  async function getOneUser() {
    await axios
      .get(`${server}Btn_First_Column/${option}`, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => {
        dispatch({
          type: "FETCH_SUCCESS",
          payload: response.data,
          title: response.data[0].Nom_CategoryBtn,
        });
      })
      .catch((error) => {
        dispatch({ type: "FETCH_ERROR", payload: error.response });
      });
  }

  // function SetEyeValOG() {
  //   if (state.Nom_Detail_1 && !state.Nom_Detail_2 && !state.Nom_Detail_3) {
  //     let EyeVal = state.Nom_Detail_1;
  //     dispatch({
  //       type: ACTION.Fill_FORM_DATA_3_COLUMN_og,
  //       payload: `${state.og ? state.og : ""} - ${EyeVal}`,
  //     });
  //   } else if (
  //     state.Nom_Detail_1 &&
  //     state.Nom_Detail_2 &&
  //     !state.Nom_Detail_3
  //   ) {
  //     let EyeVal = `${state.Nom_Detail_1}: ${state.Nom_Detail_2}`;
  //     dispatch({
  //       type: ACTION.Fill_FORM_DATA_3_COLUMN_og,
  //       payload: `${state.og ? state.og : ""} - ${EyeVal}`,
  //     });
  //   } else if (state.Nom_Detail_1 && state.Nom_Detail_2 && state.Nom_Detail_3) {
  //     let EyeVal = `${state.Nom_Detail_1}: ${state.Nom_Detail_2} ${state.Nom_Detail_3}`;
  //     dispatch({
  //       type: ACTION.Fill_FORM_DATA_3_COLUMN_og,
  //       payload: `${state.og ? state.og : ""} - ${EyeVal}`,
  //     });
  //   }
  // }

  function SetEyeValOD() {
    if (state.Nom_Detail_1 && !state.Nom_Detail_2 && !state.Nom_Detail_3) {
      let EyeVal = state.Nom_Detail_1;
      dispatch({
        type: ACTION.Fill_FORM_DATA_3_COLUMN_od,
        payload: `${state.od ? state.od : ""} - ${EyeVal}`,
      });
    } else if (
      state.Nom_Detail_1 &&
      state.Nom_Detail_2 &&
      !state.Nom_Detail_3
    ) {
      let EyeVal = `${state.Nom_Detail_1}: ${state.Nom_Detail_2}`;
      dispatch({
        type: ACTION.Fill_FORM_DATA_3_COLUMN_od,
        payload: `${state.od ? state.od : ""} - ${EyeVal}`,
      });
    } else if (state.Nom_Detail_1 && state.Nom_Detail_2 && state.Nom_Detail_3) {
      let EyeVal = `${state.Nom_Detail_1}: ${state.Nom_Detail_2} ${state.Nom_Detail_3}`;
      dispatch({
        type: ACTION.Fill_FORM_DATA_3_COLUMN_od,
        payload: `${state.od ? state.od : ""} - ${EyeVal}`,
      });
    }
  }

  useEffect(() => {
    getOneUser();
  }, [state.open]);

  const onValueChanged = async () => {
    const ValuesToCreate = {
      fk_id_patientConsul: ID,
      created_by: AuthState.user_name,
      og: state.og,
      od: state.od,
      fk_id_examen: 2,
      observation: state.observation,
    };

    axios({
      method: "post",
      responseType: "json",
      url: `${server}Consultation`,
      data: ValuesToCreate,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        syncData(response.data);
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };

  const onGridReady = (params) => {
    setGridColumnApi(params.columnApi);
    setGridApi(params.api);
  };

  const onSelectionChanged = (e) => {
    if (e.api.getSelectedRows()[0] === undefined) {
      const emptyCheckbox = {
        id_examen: "",
        Nom_CategoryBtn: "",
        Nom_Detail_1: "",
        fk_id_categoryBtn: "",
        id_detail_1: "",
      };
      dispatch({
        type: ACTION.LOAD_FIRST_TABLE,
        value: emptyCheckbox,
      });
    } else {
      let clientArray = e.api.getSelectedRows()[0];

      dispatch({
        type: ACTION.LOAD_FIRST_TABLE,
        value: clientArray,
      });
    }
  };

  const onCellValueChanged = async ({ data }) => {
    axios({
      method: "put",
      responseType: "json",
      url: `${server}Btn_First_Column`,
      data: data,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        dispatch({
          type: ACTION.LOAD_FIRST_TABLE,
          value: data,
        });
        getOneUser();
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };

  const handleRemoveItem1 = async () => {
    axios({
      method: "DELETE",
      responseType: "json",
      url: `${server}Btn_First_Column/${state.fk_id_categoryBtn}/${state.id_detail_1}`,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then(() => {
        dispatch({ type: ACTION.DELETE_SUCCESS });
        getOneUser();
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };

  return (
    <>
      <Button
        color="blue"

        onClick={() => dispatch({ type: ACTION.OPEN, size: "large" })}
      >
        Motifs CS
      </Button>
      <Modal
        size={state.size}
        open={state.open}
        onClose={() => {
          dispatch({ type: ACTION.CLOSE });
        }}
      >
        <Modal.Header className="center3columnheaders">Motifs CS</Modal.Header>
        <Modal.Content>
          <Grid>
            <Grid.Column width={6}>
              <div
                id="myGrid"
                className="ag-theme-alpine"
                style={{
                  height: "60vh",
                  width: "100%",
                }}
              >
                <AgGridReact
                  rowData={state.rowData ? state.rowData : []}
                  animateRows={true}
                  sortingOrder={["desc", "asc", null]}
                  onGridReady={onGridReady}
                  columnDefs={columnDefs}
                  defaultColDef={defaultColDef}
                  rowSelection={"single"}
                  onSelectionChanged={onSelectionChanged}
                  undoRedoCellEditing={true}
                  undoRedoCellEditingLimit={40}
                  onCellValueChanged={onCellValueChanged}
                ></AgGridReact>
              </div>
              <br />
              <Button negative onClick={handleRemoveItem1} floated="right" icon>
                <Icon name="delete" />
              </Button>
            </Grid.Column>
            <Grid.Column width={3} textAlign="center">
              {/* <Menu fluid vertical> */}
              {/* <Menu.Item ><Button onClick={() => SetEyeValOG()}>OG</Button></Menu.Item> */}
              {/* <Menu.Item> */}
              <Button onClick={() => SetEyeValOD()}>Ajouter</Button>
              {/* </Menu.Item> */}
              {/* </Menu> */}
            </Grid.Column>
            <Grid.Column width={7}>
              {/* <Segment>
                                <TextArea className="motifCSTextArea" value={state.og} placeholder="Formulaire réservé à l'oeil gauche" onChange={(e, data) => dispatch({ type: ACTION.Fill_FORM_DATA_3_COLUMN_og, payload: data.value })} />
                            </Segment> */}
              <Segment>
                <TextArea
                  autoFocus
                  className="motifCSTextArea"
                  value={state.od}
                  placeholder="Motifs CS"
                  onChange={(e, data) => {
                    // console.log(state.od);
                    dispatch({
                      type: ACTION.Fill_FORM_DATA_3_COLUMN_od,
                      payload: e.target.value,
                    });
                  }}
                />
              </Segment>
              <Segment>
                <TextArea
                  className="motifCSTextArea"
                  placeholder="Formulaire réservé aux observations"
                  onChange={(e, data) =>
                    dispatch({
                      type: ACTION.Fill_FORM_DATA_3_COLUMN_observation,
                      payload: data.value,
                    })
                  }
                />
              </Segment>
            </Grid.Column>
          </Grid>

          {/* <div
                                id="myGrid"
                                className="ag-theme-alpine"
                                style={{
                                    height: "30vh",
                                    width: "33.3%",
                                }}
                            >
                                <AgGridReact
                                    rowData={state.rowData2 ? state.rowData2 : []}
                                    animateRows={true}
                                    sortingOrder={["desc", "asc", null]}
                                    onGridReady={onGridReady}
                                    columnDefs={columnDefs2}
                                    defaultColDef={defaultColDef2}
                                    rowSelection={"single"}
                                    onSelectionChanged={onSelectionChanged2}
                                    undoRedoCellEditing={true}
                                    undoRedoCellEditingLimit={40}
                                    onCellValueChanged={onCellValueChanged2}
                                ></AgGridReact>
                            </div>
                            <div
                                id="myGrid"
                                className="ag-theme-alpine"
                                style={{
                                    height: "30vh",
                                    width: "33.3%",
                                }}
                            >
                                <AgGridReact
                                    rowData={state.rowData3 ? state.rowData3 : []}
                                    animateRows={true}
                                    sortingOrder={["desc", "asc", null]}
                                    onGridReady={onGridReady}
                                    columnDefs={columnDefs3}
                                    defaultColDef={defaultColDef3}
                                    rowSelection={"single"}
                                    onSelectionChanged={onSelectionChanged3}
                                    undoRedoCellEditing={true}
                                    undoRedoCellEditingLimit={40}
                                    onCellValueChanged={onCellValueChanged3}
                                ></AgGridReact>
                            </div> */}
          {/* </Form.Group> */}

          {/* <Form.Group widths='equal'>
                            <Form.Button width={1} onClick={() => SetEyeValOG()}>OG</Form.Button>
                            <Form.TextArea rows={2} width={4} value={state.og} placeholder="Formulaire réservé à l'oeil gauche" onChange={(e, data) => dispatch({ type: ACTION.Fill_FORM_DATA_3_COLUMN_og, payload: data.value })} />
                            <Form.Button width={1} onClick={() => SetEyeValOD()}>OD</Form.Button>
                            <Form.TextArea rows={2} width={4} value={state.od} placeholder="Formulaire réservé à l'oeil droit" onChange={(e, data) => dispatch({ type: ACTION.Fill_FORM_DATA_3_COLUMN_od, payload: data.value })} />
                            <Form.TextArea rows={2} width={6} placeholder="Formulaire réservé aux observations" onChange={(e, data) => dispatch({ type: ACTION.Fill_FORM_DATA_3_COLUMN_observation, payload: data.value })} />
                        </Form.Group> */}

          {/* </Form> */}
        </Modal.Content>
        <Modal.Actions>
          <Button
            color="blue"
            onClick={() => {
              // setSelectedCategorie("")
              dispatch({ type: ACTION.CLOSE });
            }}
          >
            Retour
          </Button>
          <Button positive onClick={onValueChanged}>
            Valider
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
}

export default Note;
